module.exports = function (app, mod, invite) {
  var time = invite.time_finished || invite.time_created;
  var datetime = app.browser.formatDate(time);
  var date = datetime.hours + ':' + datetime.minutes;
  if (invite.time_finished) {
    date += ', ' + datetime.day + ' ' + datetime.month;
  }
  var players_html = "<div class=\"league_recent_players_list\">";
  // render players who have joined
  for (var i = 0; i < invite.players.length; i++) {
    var _invite$winner;
    players_html += "\n          <div class=\"league_recent_player".concat((_invite$winner = invite.winner) !== null && _invite$winner !== void 0 && _invite$winner.includes(invite.players[i]) ? ' winner' : '', "\"><img class=\"saito-module-identicon saito-identicon\" id-").concat(invite.players[i], "\" src=\"").concat(app.keychain.returnIdenticon(invite.players[i]), "\"></div>\n\n      ");
  }
  players_html += '</div>';
  return "\n        <div class=\"saito-table-row league_recent_game\" id=\"saito-game-".concat(invite.game_id, "\">\n          <div class=\"league_recent_date\">").concat(date, "</div>").concat(players_html, "<div class=\"league_recent_cause\">").concat(invite.method ? invite.method : (invite === null || invite === void 0 ? void 0 : invite.step) || 0, "</div>\n        </div>\n    ");
};